module.exports = __webpack_public_path__ + "img/35_15.d6df6a43.png";